import { createManager } from '../createManager';
export var createCheckboxManager = function createCheckboxManager(config) {
  if (config === void 0) {
    config = {};
  }
  return createManager(Object.assign({}, config, {
    state: Object.assign({
      checked: false
    }, config.state),
    actions: Object.assign({
      toggle: function toggle(checked) {
        return function () {
          return {
            checked: checked
          };
        };
      }
    }, config.actions)
  }));
};
//# sourceMappingURL=checkboxManager.js.map
